"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = exports.updateValue = exports.newCustomerErrorsLens = exports.isFetchingLens = exports.creatingCompanyLens = exports.fetchingSelectedCompanyLens = exports.newCustomerModalLens = exports.createErrorLens = exports.companiesLens = exports.valuesLens = exports.searchStringLens = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const actionTypes = require("../../actionTypes/firstLogin/customer");
exports.searchStringLens = monocle.Lens.fromProp('searchString');
exports.valuesLens = monocle.Lens.fromProp('values');
const customerValueLens = monocle.Lens.fromPath(['values']);
exports.companiesLens = monocle.Lens.fromProp('companies');
exports.createErrorLens = monocle.Lens.fromProp('createError');
exports.newCustomerModalLens = monocle.Lens.fromProp('newCustomerModal');
exports.fetchingSelectedCompanyLens = monocle.Lens.fromProp('fetchingSelectedCompany');
exports.creatingCompanyLens = monocle.Lens.fromProp('creatingCompany');
exports.isFetchingLens = monocle.Lens.fromProp('isFetching');
const newCustomerErrorStatusLens = monocle.Lens.fromPath(['values', 'status']);
exports.newCustomerErrorsLens = new monocle.Optional((a) => (a.status === 'ERROR' ? fp.option.some(a.errors) : fp.option.none), (a) => (s) => (s.status === 'ERROR' ? Object.assign(Object.assign({}, s), { errors: a }) : s));
const updateValue = (key) => monocle.Lens.fromPath(['values', key]);
exports.updateValue = updateValue;
//#endregion
const initialValues = {
    status: 'INITIAL',
    name: '',
    businessId: '',
    hasBusinessId: true,
    street: '',
    postalCode: '',
    city: '',
    state: '',
    country: ''
};
exports.initialState = {
    status: 'STANDBY',
    searchString: '',
    isFetching: false,
    fetchingSelectedCompany: 'STANDBY',
    creatingCompany: 'STANDBY',
    createError: undefined,
    companies: [],
    newCustomerModal: false,
    values: Object.assign({}, initialValues)
};
const methods = {};
exports.methods = methods;
methods[actionTypes.SEARCH_CUSTOMER_REQUEST] = (state, action) => exports.isFetchingLens.set(true)(state);
methods[actionTypes.SEARCH_CUSTOMER_SUCCESS] = (state, action) => fp.function.compose(exports.isFetchingLens.set(false), exports.companiesLens.set(action.payload))(state);
methods[actionTypes.SEARCH_CUSTOMER_FAILED] = (state, action) => exports.isFetchingLens.set(false)(state);
methods[actionTypes.SET_CUSTOMER_SEARCH_STRING] = (state, action) => exports.searchStringLens.set(action.payload)(state);
methods[actionTypes.TOGGLE_NEW_CUSTOMER_MODAL] = (state, action) => fp.function.compose(exports.newCustomerModalLens.modify((x) => action.payload !== null ? action.payload : !x), exports.creatingCompanyLens.set('STANDBY'), exports.searchStringLens.set(''), exports.createErrorLens.set(undefined), exports.valuesLens.set(Object.assign({}, initialValues)))(state);
methods[actionTypes.UPDATE_NEW_CUSTOMER_FIELD] = (state, action) => fp.function.compose((0, exports.updateValue)(action.payload.key).set(action.payload.value), customerValueLens
    .asOptional()
    .compose(exports.newCustomerErrorsLens)
    .modify((x) => {
    delete x[action.payload.key];
    return x;
}))(state);
methods[actionTypes.SET_YTJ_COMPANY_REQUEST] = (state, action) => exports.fetchingSelectedCompanyLens.set('FETCHING')(state);
methods[actionTypes.SET_YTJ_COMPANY_SUCCESS] = (state, action) => fp.function.compose(exports.fetchingSelectedCompanyLens.set('FETCHED'), (0, exports.updateValue)('name').set(action.payload.name), (0, exports.updateValue)('businessId').set(action.payload.businessId || ''), (0, exports.updateValue)('hasBusinessId').set(!!action.payload.businessId), (x) => {
    const addressDetails = action.payload.addressDetails;
    if (addressDetails) {
        return fp.function.compose((0, exports.updateValue)('street').set(addressDetails.street), (0, exports.updateValue)('postalCode').set(addressDetails.postalCode), (0, exports.updateValue)('city').set(addressDetails.city), (0, exports.updateValue)('state').set(addressDetails.state || ''), (0, exports.updateValue)('country').set(addressDetails.country))(x);
    }
    return fp.function.compose((0, exports.updateValue)('street').set(''), (0, exports.updateValue)('postalCode').set(''), (0, exports.updateValue)('city').set(''), (0, exports.updateValue)('state').set(''), (0, exports.updateValue)('country').set(''))(x);
})(state);
methods[actionTypes.SET_YTJ_COMPANY_FAILURE] = (state, action) => exports.fetchingSelectedCompanyLens.set('FAILED')(state);
methods[actionTypes.CREATE_CUSTOMER_REQUEST] = (state, action) => exports.creatingCompanyLens.set('SAVING')(state);
methods[actionTypes.CREATE_CUSTOMER_SUCCESS] = (state, action) => fp.function.compose(exports.creatingCompanyLens.set('SAVED'), exports.companiesLens.set([action.payload]))(state);
methods[actionTypes.CREATE_CUSTOMER_FAILED] = (state, action) => fp.function.compose(exports.creatingCompanyLens.set('FAILED'), exports.createErrorLens.set(action.payload))(state);
methods[actionTypes.VALIDATE_CUSTOMER_FAILURE] = (state, action) => {
    return fp.function.compose(customerValueLens
        .asOptional()
        .compose(exports.newCustomerErrorsLens)
        .set(action.payload.errors.reduce((rv, x) => {
        ;
        (rv[x.key] = rv[x.key] || []).push(x.value);
        return rv;
    }, {})), exports.creatingCompanyLens.set('FAILED'), newCustomerErrorStatusLens.set('ERROR'))(state);
};
//# sourceMappingURL=customer.js.map